<template>
  <div>
    <div class="UserLogin">
      <!-- 登录 -->
      <el-dialog :title="wxlogin?'微信登录':'用户登录'" :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      >
        <div class="left-img"></div>
        <div class="login-menu" v-if="!imageBool && !wxlogin">
          <el-form :model="loginForm" :rules="rules" ref="loginForm">
            <el-form-item prop="userName">
              <el-input placeholder="请输入手机号" prefix-icon="el-icon-user" v-model="loginForm.userName">
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input @keyup.enter.native="loginBtn(loginForm)" placeholder="请输入密码" prefix-icon="el-icon-lock" type="password" v-model="loginForm.password">
              </el-input>
            </el-form-item>
          </el-form>
          <div class="forget">
            <p @click="forgetBtn" class="hint">忘记密码</p>
          </div>
          <el-button @click="loginBtn(loginForm)">登录</el-button>
          <div class="other-login">还没有账号？<span @click="hintBtn">立即注册</span></div>
          <!-- <div class="other-login-wx" @click="wxlogin = !wxlogin"><el-image :src="require('../../../assets/image/login/weixin@2x.png')" fit="fill" :lazy="true"></el-image>
          </div> -->
        </div>
        <div class="login-menu" v-if="!imageBool && wxlogin">
          <div class="codes" ref="codes">
            <iframe frameborder="0" sandbox="allow-scripts allow-top-navigation allow-same-origin" scrolling='no' src="/portal/oauth/wechat_open"></iframe>
          </div>
          <div @click="wxlogin = !wxlogin" class="mimalogin">密码登录</div>
        </div>
        <div class="image-verify-box" v-if="imageBool && !wxlogin">
          <div>
            <img :src="'data:image/png;base64,' + imageList.smallImage" :style="
                  'top:' + imageList.yHeight + 'px;left:' + smallWidth + 'px'" id="smallImage"/>
            <img :src="'data:image/jpeg;base64,' + imageList.bigImage" id="bigImage"/>
            <div @click="refreshImage" class="el-icon-refresh"></div>
          </div>
          <el-slider :class="imageSliderState" :key="imageList.xWidth" :max="320" :min="0" :show-tooltip="false" @change="changeImageSlider" @input="changeSmallImage" v-model="sliderValue">
          </el-slider>
        </div>
      </el-dialog>
    </div>
    <ForgetPassword ref="ForgetPassword"/>
    <Sign ref="Sign"/>
  </div>
</template>
<script>
  import {getIntranet, loginByImg} from "@/utils/router/login.api";
  import {getImageVerifyCode} from "@/utils/plugin/verifyImage";
  import ForgetPassword from "./ForgetPassword .vue";
  import Sign from "./Sign.vue";

  export default {
    name: "Login",
    components: {ForgetPassword, Sign},
    data() {
      return {
        loginState: {},
        ipAddress: "",
        dialogVisible: false,
        loginForm: {},
        //验证码
        imageBool: false,
        sliderValue: 8,
        smallWidth: "0px",
        imageSliderState: "",
        imageList: {
          bigImage: "",
          smallImage: "",
          xWidth: 0,
          yHeight: 0,
        },
        // 注册
        show: true,
        times: "",
        timer: null,
        details: {
          userName: "",
          imageVerification: "",
          telCode: "",
          password: "",
          checkPass: "",
          typeId: this.$store.state.typeId,
        },
        imgcode: "/portal/reader/imageVerification",
        rules: {
          userName: [{required: true, message: "必填"}],
          password: [{required: true, message: "必填"}],
        },
        checked: false,
        wxlogin: false
      };
    },
    methods: {
      //获取图形
      getImage() {
        getImageVerifyCode().then((res) => {
          if (res && res.data.data) {
            this.imageBool = true;
            this.imageList = res.data.data;
            this.sliderValue = 8;
          }
        });
      },
      //验证图形刷新
      refreshImage() {
        this.imageSliderState = "";
        this.sliderValue = 8;
        this.smallWidth = "0px";
        this.getImage();
      },
      //图形验证
      changeImageSlider(value) {
        if (Math.abs(this.imageList.xWidth - value) < 10) {
          this.imageSliderState = "verify-success";
          this.imageBool = false;
          this.loginLoading = true;
          setTimeout((res) => {
            this.setLogin();
          }, 1000);
        } else {
          this.imageSliderState = "verify-fail";
          setTimeout((res) => {
            this.refreshImage();
          }, 1000);
        }
      },
      //滑动拼图
      changeSmallImage(value) {
        value < 260 && (this.smallWidth = value);
      },
      openDialog() {
        this.dialogVisible = true;
        this.imageBool = false;
        this.loginForm = Object.assign({});
      },
      setLogin() {
        loginByImg({
          userName: this.loginForm.userName,
          password: this.$md5(this.loginForm.password),
          moveLength: this.sliderValue,
        }).then((res) => {
          if (res && res.data.code === 200) {
            this.$message({
              type: "success",
              message: "登录成功",
            });
            this.dialogVisible = false;
            sessionStorage.setItem("portal_user_info", JSON.stringify(res.data.data));
            location.reload()
            // this.$router.push('/sort')
          } else {
            this.$alert(res.data.message);
          }
        });
      },
      loginBtn() {
        this.$refs["loginForm"].validate((valid) => {
          if (valid) {
            this.imageBool = true;
            this.getImage();
          }
        });
      },
      ready() {
        //js 引入 <!-- 获取本机ip  -->
        //<script src="http://pv.sohu.com/cityjson?ie=utf-8">
        var cip = returnCitySN["cip"];
        //给vuedata对象里的字段赋值
        this.ipAddress = cip;
        //IP白名单
        getIntranet({
          ipType: "1",
          ip: this.ipAddress,
          typeId: this.$store.state.typeId,
        }).then((res) => {
          if (res && res.data.code == 200) {
            this.$store.commit("setIpAddress", {
              ip: this.ipAddress,
              visible: res.data.data,
            });
          }
        });
      },
      getIp() {
        //获取内网ip
        var that = this;
        var RTCPeerConnection =
          window.RTCPeerConnection ||
          window.webkitRTCPeerConnection ||
          window.mozRTCPeerConnection;
        if (RTCPeerConnection)
          (function () {
            var rtc = new RTCPeerConnection({iceServers: []});
            if (1 || window.mozRTCPeerConnection) {
              rtc.createDataChannel("", {reliable: false});
            }

            rtc.onicecandidate = function (evt) {
              if (evt.candidate) grepSDP("a=" + evt.candidate.candidate);
            };
            rtc.createOffer(
              function (offerDesc) {
                grepSDP(offerDesc.sdp);
                rtc.setLocalDescription(offerDesc);
              },
              function (e) {
                console.warn("offer failed", e);
              }
            );
            var addrs = Object.create(null);
            addrs["0.0.0.0"] = false;

            function updateDisplay(newAddr) {
              if (newAddr in addrs) return;
              else addrs[newAddr] = true;
              var displayAddrs = Object.keys(addrs).filter(function (k) {
                return addrs[k];
              });
              for (var i = 0; i < displayAddrs.length; i++) {
                if (displayAddrs[i].length > 16) {
                  displayAddrs.splice(i, 1);
                  i--;
                }
              }
              //打印出该设备连接的所有内网ip
              that.$store.commit("setIpLocal", displayAddrs[0]);
            }

            function grepSDP(sdp) {
              var hosts = [];
              sdp.split("\r\n").forEach(function (line, index, arr) {
                if (~line.indexOf("a=candidate")) {
                  var parts = line.split(" "),
                    addr = parts[4],
                    type = parts[7];
                  if (type === "host") updateDisplay(addr);
                } else if (~line.indexOf("c=")) {
                  var parts = line.split(" "),
                    addr = parts[2];
                  updateDisplay(addr);
                }
              });
            }
          })();
        else {
          console.log("请使用主流浏览器：chrome,firefox,opera,safari");
        }
      },
      forgetBtn() {
        this.$refs.ForgetPassword.openDialog(false);
      },
      hintBtn() {
        // this.dialogVisible = false;
        this.$refs.Sign.openDialog(false);
      },

    },
    created() {
      this.loginState = JSON.parse(sessionStorage.getItem('portal_user_info'))
      if (this.loginState) {
        this.$store.commit('setUserInfo', {
          userId: this.loginState.id || '',
          userName: this.loginState.userName || '',
          nickname: this.loginState.nickname || '',
        });
      }

    }
  }
</script>

<style lang="less" scoped>
  .UserLogin {

    /deep/ .el-dialog {
      width: 27.083rem;
      height: 31.25rem;
      border-radius: 0 0.521rem 0.521rem 0;
      margin-left: 50%;
    }

    .left-img {
      width: 27.083rem;
      height: 31.25rem;
      background: url("../../../assets/image/login/login_bg.png");
      position: absolute;
      top: 0;
      left: -27.083rem;
    }

    .forget {
      padding-left: 19.167rem;

      p {
        cursor: pointer;
        color: #b1222b;
      }
    }

    .other-login {
      padding-left: 9.167rem;
      margin-top: 2.188rem;

      span {
        cursor: pointer;
        color: #b1222b;
      }
    }

    .other-login-wx {
      text-align: center;
      margin-top: 30px;
      cursor: pointer;

      .el-image {
        width: 40px;
        height: 40px;
      }
    }

    .login-menu {
      background-size: 100%;
      margin: auto;

      .el-button {
        width: 18.75rem;
        // height: 46px;
        background-color: #b1222b;
        border-radius: 6px;
        color: #fff;
        font-size: 16px;
        margin-left: 70px;
        margin-top: 36px;
        letter-spacing: 2px;
      }

      .el-form {
        padding-left: 70px;
      }

      .codes {
        display: flex;
        justify-content: center;
        align-items: center;

        iframe {
          width: 350px;
          height: 350px;
        }
      }

      .mimalogin {
        text-align: right;
        cursor: pointer;
        font-size: 16px;
        padding-right: 15px;
      }
    }

    /deep/ .el-form {
      padding: 0;
    }

    /deep/ .el-dialog__header {
      height: 7.958rem;
      padding: 4.896rem 0 0 0;
      text-align: center;
    }

    /deep/ .el-dialog__title {
      font-size: 1.771rem;
      line-height: 60px;
    }

    /deep/ .el-input__icon {
      font-size: 18px;
    }

    /deep/ .el-dialog__headerbtn {
      right: 46px;
      padding: 0;
    }

    /deep/ .el-input--small .el-input__inner {
      width: 18.75rem;
      height: 2.604rem;
      border-radius: 0.313rem;
      font-size: 0.833rem;
    }

    /deep/ .el-form-item {
      margin-top: 1.563rem;
    }

    /deep/ .el-input__inner:focus {
      border-color: #9d2236;
    }
  }

  //图形验证码
  .image-verify-box {
    position: relative;
    left: 95px;
    top: 20px;

    /deep/ .verify-success {
      .el-slider__button {
        background: #2ac845;
      }
    }

    /deep/ .verify-fail {
      .el-slider__button {
        background: #ff0000;
      }
    }

    /deep/ .el-slider {
      width: 320px;
      height: 40px;
      line-height: 40px;
      background-image: none;
      background-color: rgba(0, 0, 0, 0.03);
      border: solid 1px #eee;
      text-align: center;
      font-size: 18px;
      color: #0c0c0c;
      position: relative;
    }

    /deep/ .el-slider__runway {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: none;
      border: none;
      text-align: center;
      font-size: 18px;
      color: #0c0c0c;
      position: relative;
      margin: 0 0;
    }

    /deep/ .el-slider__runway:after {
      content: "请完成安全认证";
    }

    /deep/ .el-slider__button-wrapper {
      width: 40px;
      height: 46px;
      border-radius: 5px;
      border: 1px solid #409eff;
      background-color: #409eff;
      cursor: pointer;
      margin-left: 20px;
      position: absolute;
      top: -4px;
    }

    /deep/ .el-slider__bar {
      height: 40px;
    }

    #smallImage {
      width: 60px;
      height: 60px;
      position: absolute;
    }

    #bigImage {
      width: 320px;
      height: 180px;
    }

    .el-icon-refresh {
      color: #e0e0e0;
      cursor: pointer;
      font-size: 20px;
      position: relative;
      left: 291px;
      top: -177px;
    }

    .el-icon-refresh:hover {
      color: #fff;
    }
  }

  /deep/ .el-dialog__body {
    padding: 0;
  }

  /deep/ .el-dialog__wrapper {
    background: url("../../../assets/image/index/index_bg.png") no-repeat;
    background-size: 100% 100%;
    // margin-top: 4.179rem;
    padding-top: 3.179rem;
  }

  /deep/ .el-icon-close:before {
    color: #9d2236;
    content: '返回上一页';
  }
</style>
